module.exports = __webpack_public_path__ + "img/ic24PetBody.7bd74994.svg";